import React, { useState, useEffect } from "react";
import MaterialTable from 'material-table'
import { useNavigate } from 'react-router-dom'
import { API } from "../../backend";
import authHeader from "../../services/auth-header";
import Helper from "../../Helper";
import { getTrans as t } from "../../Localization/translations";
import ContentLoader from "react-content-loader";
import _ from "lodash";

function ContractList({ id }) {

const tableRefcontract = React.createRef();
const [loading, setLoading] = useState(true);

// const [items, setItems] = useState([]);
const [permissionss,setPermission] = useState(localStorage.getItem('permissions'))
const permissionsArray = permissionss.split(',');
	
useEffect(() => {
	setLoading(false)
}, []);

let navigate = useNavigate();

const handleView = (id, status,contract_type) => {
	if (status === "Active") {
		navigate("/contract/view", { state: id });
	  } else if (status === "Terminated") {
		navigate("/contract/view", { state: id });
	  } else {
		if (contract_type === "Loan") {
		  navigate("/editloancontract", { state: id });
		} else if (contract_type === "Rental") {
		  navigate("/editrentalcontract", { state: id });
		} else {
		  navigate("/contract/edit", { state: id });
		}
	  }
}

return (
<div className="row">
	{
		loading === false ? (
			<div className="col-md-12 filter_contract">
				<div className=" mb-0">
					<div className="header pb-0">
						<div className="d-lg-flex mb-2">
							<div>
								<h5 className="mb-0">{t('View Contracts')}</h5>
							</div>
						</div>
					</div>
					<div className="body">
						<MaterialTable
                            tableRef={tableRefcontract}
							style={{
								backgroundColor: "var(--bs-table-bg)",
								borderBottomWidth: "1px",
								boxShadow: "inset 0 0 0 9999px var(--bs-table-accent-bg)",
							}}
							columns={[
								{
									title: `${t("Contract Number")}`,
									field: "contract_number",
									headerStyle: {
										verticalAlign: "inherit",
										fontWeight: "bold",
										textAlign: "left"
									},
									cellStyle: {
										textAlign: "left",
										fontSize: 12
									},
									render: rowData =><><div className="d-xl-none tc d-md-none d-lg-none">{t("Contract Number")}</div> <div className="hyperlink"  onClick={() =>
										rowData.status ==="Entered"?
										permissionss &&  permissionsArray.includes('change_contract')===true :
										permissionss &&  permissionsArray.includes('view_contract')===true ?
										handleView(
										  rowData.id,
										  rowData.status,
										  rowData.contract_type
										):""
									  }>{rowData.contract_number}</div></>
								},
								{
									title: `${t("Customer")}`,
									field: "customer_name",
									render: rowData =>  <><div className="d-xl-none tc d-md-none d-lg-none">{t("Customer")}</div> <div>{rowData.customer_name}</div></>,
									headerStyle: {
										verticalAlign: "inherit",
										fontWeight: "bold",
										textAlign: "left"
									},
									cellStyle: {
										textAlign: "left",
										fontSize: 12
									}
								},
								{
									title: `${t("Contract Type")}`,
									field: "contract_type",
									render : rowData => <><div className="d-xl-none tc d-md-none d-lg-none"> {t("Contract Type")}</div><div >{rowData.contract_type}</div></>,
									headerStyle: {
										verticalAlign: "inherit",
										fontWeight: "bold",
										textAlign: "left"
									},
									cellStyle: {
										textAlign: "left",
										fontSize: 12
									}
								},
								{
									title: `${t("Start Date")}`,
									field: "start_date",
									render: rowData => <><div className="d-xl-none tc d-md-none d-lg-none">{t("Start Date")}</div><div >{Helper.DateNormal(rowData.start_date)}</div></>,
									headerStyle: {
										verticalAlign: "inherit",
										fontWeight: "bold",
										textAlign: "left"
									},
									cellStyle: {
										textAlign: "left",
										fontSize: 12
									}
								}, {
									title: `${t("Term")}`,
									field: "contract_term",
									render: rowData => <><div className="d-xl-none tc d-md-none d-lg-none">{t("Term")}</div><div >{(rowData.contract_term)}</div></>,
									headerStyle: {
										verticalAlign: "inherit",
										fontWeight: "bold",
										textAlign: "left"
									},
									cellStyle: {
										textAlign: "left",
										fontSize: 12
									}
								}, {
									title: `${t("End Date")}`,
									field: "end_date",
									render: rowData => <><div className="d-xl-none tc d-md-none d-lg-none">{t("End Date")}</div><div >{rowData.end_date ? Helper.DateNormal(rowData.end_date) : "None"}</div></> ,
									headerStyle: {
										verticalAlign: "inherit",
										fontWeight: "bold",
										textAlign: "left"
									},
									cellStyle: {
										textAlign: "left",
										fontSize: 12
									}
								}, {
									title: `${t("Financed Amount")}`,
									field: "financed_amount",
									render: rowData => <><div  className={`d-xl-none tc d-md-none d-lg-none`} style={{ textAlign: rowData.isSmallScreen ? 'left' : 'right', fontSize: '12px', fontWeight: rowData.isSmallScreen ? 'bold' : '' }}
									>{t("Financed Amount")}</div><div className={`d-none d-xl-block d-lg-block text-right`} style={{ textAlign: 'right', fontSize: '12px' }}>{rowData.financed_amount===0 ?Helper.Amount(rowData.financed_amount):Helper.Amount(rowData.financed_amount - rowData.deposit_amount)}</div></>,
									headerStyle: {
										verticalAlign: "inherit",
										fontWeight: "bold",
										textAlign: "right"
									},
									// cellStyle: {
									// 	textAlign: "right",
									// 	fontSize: 12
									// }
								}, {
									title: `${t("Status")}`,
									field: "status",
									render: rowData =><><div className="d-xl-none tc d-md-none d-lg-none">{t("Status")}</div><div className={rowData.status === "Active" ? 'badge bg-gradient-success text-xxs' : rowData.status === "Terminated" || rowData.status === "PaidOff" ? 'badge bg-gradient-danger text-xxs' : 'badge badge-sm bg-gradient-secondary'}>{(rowData.status)}</div></> ,
									headerStyle: {
										verticalAlign: "inherit",
										fontWeight: "bold",
										textAlign: "left"
									},
									cellStyle: {
										textAlign: "left",
										fontSize: 12
									}
								},
							]}
							data={query =>
								new Promise((resolve, reject) => {
									const { orderBy, orderDirection } = query;

								  let url = API + "parties/partycontract/" + id + "/?"
								  url += 'per_page=' + query.pageSize
								  url += '&page=' + (query.page + 1)
								  url += '&search=' + query.search
								  if (orderBy) {
									url += `&orderBy=${orderBy.field}`;
									url += `&orderDirection=${orderDirection}`;
									}
								  fetch(url, { headers: authHeader() })
									.then(response => response.json())
									.then(result => {
									  resolve({
										data: query.orderBy && query.orderDirection
										? _.orderBy(
											result.data,
											[query.orderBy.field],
											[query.orderDirection]
										  )
										: result.data,
										page: result.page - 1,
										totalCount: result.total,
									  })
									})
								})
							  }
							options={{
								headerStyle: {
									backgroundColor: "white",
									color: "#245C7F",
									 fontSize: 12,
								},
								rowStyle: (rowData, index) => {
									if (index % 2) {
										return { backgroundColor: "#fff" }
									}
								},
								sorting: true,
								search: false,
								toolbar: false,
								paging: true,
								pageSize:10,       // make initial page size
								emptyRowsWhenPaging: false,   // To avoid of having empty rows
								pageSizeOptions: [10, 15, 20, 50],
								paginationType: "stepped",
								showFirstLastPageButtons: false,
								actionsColumnIndex: -1,
							}}
						/>
					</div>
				</div>
			</div>
		) : (
			<ContentLoader
				viewBox="0 0 1000 550"
				backgroundColor="rgba(0,0,0,0.06)"
				foregroundColor="rgba(0,0,0,0.12)"
			>
				<rect x="51" y="45" rx="3" ry="3" width="906" height="17" />
				<circle cx="879" cy="123" r="11" />
				<circle cx="914" cy="123" r="11" />
				<rect x="104" y="115" rx="3" ry="3" width="141" height="15" />
				<rect x="305" y="114" rx="3" ry="3" width="299" height="15" />
				<rect x="661" y="114" rx="3" ry="3" width="141" height="15" />
				<rect x="55" y="155" rx="3" ry="3" width="897" height="2" />
				<circle cx="880" cy="184" r="11" />
				<circle cx="915" cy="184" r="11" />
				<rect x="105" y="176" rx="3" ry="3" width="141" height="15" />
				<rect x="306" y="175" rx="3" ry="3" width="299" height="15" />
				<rect x="662" y="175" rx="3" ry="3" width="141" height="15" />
				<rect x="56" y="216" rx="3" ry="3" width="897" height="2" />
				<circle cx="881" cy="242" r="11" />
				<circle cx="916" cy="242" r="11" />
				<rect x="106" y="234" rx="3" ry="3" width="141" height="15" />
				<rect x="307" y="233" rx="3" ry="3" width="299" height="15" />
				<rect x="663" y="233" rx="3" ry="3" width="141" height="15" />
				<rect x="57" y="274" rx="3" ry="3" width="897" height="2" />
				<circle cx="882" cy="303" r="11" />
				<circle cx="917" cy="303" r="11" />
				<rect x="107" y="295" rx="3" ry="3" width="141" height="15" />
				<rect x="308" y="294" rx="3" ry="3" width="299" height="15" />
				<rect x="664" y="294" rx="3" ry="3" width="141" height="15" />
				<rect x="58" y="335" rx="3" ry="3" width="897" height="2" />
				<circle cx="881" cy="363" r="11" />
				<circle cx="916" cy="363" r="11" />
				<rect x="106" y="355" rx="3" ry="3" width="141" height="15" />
				<rect x="307" y="354" rx="3" ry="3" width="299" height="15" />
				<rect x="663" y="354" rx="3" ry="3" width="141" height="15" />
				<rect x="57" y="395" rx="3" ry="3" width="897" height="2" />
				<circle cx="882" cy="424" r="11" />
				<circle cx="917" cy="424" r="11" />
				<rect x="107" y="416" rx="3" ry="3" width="141" height="15" />
				<rect x="308" y="415" rx="3" ry="3" width="299" height="15" />
				<rect x="664" y="415" rx="3" ry="3" width="141" height="15" />
				<rect x="55" y="453" rx="3" ry="3" width="897" height="2" />
				<rect x="51" y="49" rx="3" ry="3" width="2" height="465" />
				<rect x="955" y="49" rx="3" ry="3" width="2" height="465" />
				<circle cx="882" cy="484" r="11" />
				<circle cx="917" cy="484" r="11" />
				<rect x="107" y="476" rx="3" ry="3" width="141" height="15" />
				<rect x="308" y="475" rx="3" ry="3" width="299" height="15" />
				<rect x="664" y="475" rx="3" ry="3" width="141" height="15" />
				<rect x="55" y="513" rx="3" ry="3" width="897" height="2" />
				<rect x="52" y="80" rx="3" ry="3" width="906" height="17" />
				<rect x="53" y="57" rx="3" ry="3" width="68" height="33" />
				<rect x="222" y="54" rx="3" ry="3" width="149" height="33" />
				<rect x="544" y="55" rx="3" ry="3" width="137" height="33" />
				<rect x="782" y="56" rx="3" ry="3" width="72" height="33" />
				<rect x="933" y="54" rx="3" ry="3" width="24" height="33" />
			</ContentLoader>
		)
	}
</div>
)
}

export default ContractList